import React, { createContext, useContext, useState, useEffect } from 'react';
import { DEMO_MODE_ENABLED, DEMO_CONFIG } from '../config/demo';

const DemoContext = createContext({});

export const useDemo = () => {
  const context = useContext(DemoContext);
  if (!context) {
    throw new Error('useDemo must be used within a DemoProvider');
  }
  return context;
};

export const DemoProvider = ({ children }) => {
  const [demoAction, setDemoAction] = useState(null);

  const triggerDemoAction = (action, component = null) => {
    setDemoAction({ action, component, timestamp: Date.now() });
  };

  const clearDemoAction = () => {
    setDemoAction(null);
  };

  const value = {
    demoAction,
    triggerDemoAction,
    clearDemoAction,
    isDemoMode: DEMO_MODE_ENABLED,
  };

  return <DemoContext.Provider value={value}>{children}</DemoContext.Provider>;
};

